export default __webpack_public_path__ + "static/media/3.dc6bbbb7.webp";